import React from 'react';
import { Button } from '../ui/button';
import { ArrowRight } from 'lucide-react';

const HeroSection = ({ data, onCtaClick }) => {
  return (
    <section className="px-5 sm:px-6 py-14 md:py-20 lg:py-24 bg-white">
      <div className="max-w-3xl mx-auto text-center">
        {/* Main Headline */}
        <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-[2.75rem] font-bold text-gray-900 leading-tight mb-4 tracking-tight">
          Reliable Communal Block Cleaning — Without Missed Cleans or Resident Complaints
        </h1>
        
        {/* Authority Trust Strip */}
        <p className="text-sm sm:text-base md:text-lg text-[#1a1f4e] font-medium mb-8">
          4+ years • Fully insured • Fixed schedules • One point of contact
        </p>
        
        {/* CTA Button */}
        <Button
          onClick={onCtaClick}
          size="lg"
          data-testid="hero-cta-btn"
          className="bg-[#00c853] hover:bg-[#00a844] text-white px-6 sm:px-8 py-4 text-base sm:text-lg font-medium rounded-xl transition-all duration-200 h-auto min-h-[48px] sm:min-h-[56px] shadow-[0_2px_8px_rgba(0,200,83,0.25)] hover:shadow-[0_4px_12px_rgba(0,200,83,0.35)] hover:-translate-y-0.5 active:translate-y-0"
        >
          Get a Free Site Assessment
          <ArrowRight className="ml-2 w-5 h-5" />
        </Button>
        
        {/* Micro-copy under CTA */}
        <p className="mt-5 text-sm text-gray-500 leading-relaxed">
          No obligation • Clear monthly pricing • Response within 1 working day
        </p>
      </div>
    </section>
  );
};

export default HeroSection;
